import React from 'react';
export const FAQSections = () => {
  return <section className="mb-12" data-id="element-227" data-mp="1zkn7aqnt3jzi">
      <div className="mb-10" data-id="element-228" data-mp="3v1062u6oeg5b">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-229" data-mp="3uzp1wt9bj6do">
          "Is er een specifiek moment waarop het kwartje valt?"
        </h2>

        <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-230" data-mp="3q3rnishm8a3j">
          Er is een specifiek moment tijdens elk webinar dat Amee het
          "omslagpunt" noemt. Meestal rond minuut 20, wanneer ze een aantal
          misvattingen over dominantie uit de wereld helpt.
        </p>

        <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-231" data-mp="hmdnrk6f723x">
          <p className="text-gray-800 leading-relaxed italic" data-id="element-232" data-mp="ctu9sm3tm4yl">
            "Dan zie ik in de chat dat het kwartje valt," vertelt ze. "Mensen
            typen dingen als 'OMG, daarom doet hij dat!' of 'Dit verklaart
            alles!' Dat is het moment waarop ze overschakelen van problemen zien
            naar communicatie begrijpen."
          </p>
        </div>
      </div>

      <div className="mb-10" data-id="element-233" data-mp="2nax3rhs9y5l">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-234" data-mp="2o2un7uxy5yi">
          "Wat zeggen mensen één week na het webinar?"
        </h2>

        <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-235" data-mp="6qz4a92i6rqb">
          De echte test van de "90-minuten transformatie" komt in de dagen na
          het webinar. Kunnen mensen de nieuwe inzichten toepassen? Maken ze
          echt verschil?
        </p>

        <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-4 rounded-r-lg" data-id="element-236" data-mp="3f3wr5bs0s0oq">
          <p className="text-gray-800 leading-relaxed italic" data-id="element-237" data-mp="3k4avojuewsi0">
            "Binnen drie dagen waren onze wandelingen compleet veranderd,"
            vertelt Jeroen uit Rotterdam. "In plaats van Max corrigeren ging ik
            luisteren naar wat hij probeerde te zeggen. Nu zijn wandelingen
            ontspannen in plaats van stressvol."
          </p>
        </div>

        <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-238" data-mp="19bzrfpsyb19p">
          <p className="text-gray-800 leading-relaxed italic" data-id="element-239" data-mp="199n8b9bgikv2">
            Emma uit Gent: "Het grappige is dat Mila niet veranderd is - ik
            begrijp haar gewoon beter. Waardoor zij zich ook rustiger voelt. Het
            is een opwaartse spiraal."
          </p>
        </div>
      </div>
    </section>;
};